/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PerformanceModal_viewer = {
    readonly project: {
        readonly id: string;
        readonly name: string | null;
        readonly companyProjectId: number | null;
        readonly estimationUnit: string | null;
        readonly projectHealth: {
            readonly id: string;
            readonly performanceTotal: number | null;
        } | null;
        readonly projectStats: ReadonlyArray<{
            readonly id: string;
            readonly " $fragmentRefs": FragmentRefs<"PerformanceModalChartSection_projectStats">;
        } | null> | null;
    } | null;
    readonly " $refType": "PerformanceModal_viewer";
};
export type PerformanceModal_viewer$data = PerformanceModal_viewer;
export type PerformanceModal_viewer$key = {
    readonly " $data"?: PerformanceModal_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PerformanceModal_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimationUnit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectHealth",
          "kind": "LinkedField",
          "name": "projectHealth",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "performanceTotal",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectStats",
          "kind": "LinkedField",
          "name": "projectStats",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PerformanceModalChartSection_projectStats"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'f90455920c2150c50344773fbfd8304e';
export default node;
